import React, { useEffect, useState } from "react";
import { Spin } from "antd";

const ResetPasswordMobileCompleted = () => {
  const [loader, setLoader] = useState(true);
  const [confirmationStatus, setConfirmationStatus] = useState(null);

  useEffect(() => {
    setLoader(false); 
    setConfirmationStatus("success"); 
  }, []);

  return (
    <div className="confirm-email-mobile-container">
      {loader ? (
        <div className="loader-container">
          <Spin size="large" />
        </div>
      ) : confirmationStatus === "success" ? (
        <div className="confirmation-message">
          <h1>Password Reset Successful!</h1>
          <p>
            Your password has been reset successfully. You can now go to the
            mobile app and login again.
          </p>
        </div>
      ) : (
        <div className="confirmation-message">
          <h1>Error</h1>
          <p>
            There was an issue with the password reset process. Please try again
            later.
          </p>
        </div>
      )}
    </div>
  );
};

export default ResetPasswordMobileCompleted;
